/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { createBrowserRouter, RouterProvider } from 'react-router';

import { ExternalAppProviders } from 'shared-ui/external-app-base';

import { routes } from './routes/routes';

const router = createBrowserRouter(routes);

export default function App() {
    return (
        <ExternalAppProviders mountRateLimitNotice={false}>
            <RouterProvider router={router} />
        </ExternalAppProviders>
    );
}
